import Head from "next/head"
import React from "react"
import styled, { css } from "styled-components"

import CtaLink from "~/components/atoms/CtaLink"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import TextCut from "~/components/molecules/TextCut"
import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import SeminarHead from "~/components/organisms/SeminarHead"
import SeminarSchduleCard from "~/components/organisms/SeminarSchduleCard"
import Table from "~/components/organisms/Table"
import { SpacingSize, Color, TextSize, LineHeight, IsPC, IsMobile, Z } from "~/consts/style-mixins"
import { staticPath, internalLink } from "~/services/helper"

export default class SeminarDetail extends React.Component {
  render() {
    const crumbs = [
      {
        name: "就活セミナー・就活対策講座一覧",
        link: internalLink(`/seminars`),
      },
      {
        name: `グループディスカッション就活対策講座`,
        link: internalLink(`/seminars/1`),
      },
    ]

    return (
      <>
        <Head>
          <title>グループディスカッション就活対策講座 | Infra（インフラ）</title>
          <meta
            name="description"
            content={`グループディスカッションを実践的に行うのはもちろん、グループディスカッションの種類ごとに解説講座も実施します！それぞれに応じた対策を知ることができます。 人事担当者や総合商社内定者がメンターを務めますので、個別フィードバックがもらえるだけでなく、不安に思うことがあればなんでも聞くことができます！`}
          />
          <meta property="og:title" content="グループディスカッション就活対策講座 | Infra（インフラ）" />
          <meta
            property="og:description"
            content="グループディスカッションを実践的に行うのはもちろん、グループディスカッションの種類ごとに解説講座も実施します！それぞれに応じた対策を知ることができます。 人事担当者や総合商社内定者がメンターを務めますので、個別フィードバックがもらえるだけでなく、不安に思うことがあればなんでも聞くことができます！"
          />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header logoType="Plain" />
        <StyledContainerWrapper>
          <Container size="Medium">
            <SeminarHead
              title="グループディスカッション就活対策講座"
              bgSrc={staticPath("/static/images/seminar/seminars-1.png")}
            />
            <div>
              <StyledSchduleCardWrapper>
                <SeminarSchduleCard
                  date="11/23（土）"
                  timeStart="15:30"
                  timeEnd="18:00"
                  applicationNum={2}
                  capacityNum={10}
                  selectsByLottery
                />
              </StyledSchduleCardWrapper>
              <StyledEachItemWrapper>
                <TextCut cutPoint={240} size="Medium">
                  グループディスカッションを実践的に行うのはもちろん、グループディスカッションの種類ごとに解説講座も実施します！それぞれに応じた対策を知ることができます。
                  人事担当者や総合商社内定者がメンターを務めますので、個別フィードバックがもらえるだけでなく、不安に思うことがあればなんでも聞くことができます！
                  ぜひこの機会にこの講座を受けて、本選考に向けた実践的な対策をしましょう！
                </TextCut>
              </StyledEachItemWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">当日の流れ</StyledHeading>
                <TextCut cutPoint={240} size="Medium">
                  {`・グループディスカッション実践①抽象型\n　↓
                  ・フィードバック・解説①\n　↓
                  ・グループディスカッション実践②課題解決型\n　↓
                  ・フィードバック・解説②\n　↓
                  ・グループディスカッション実践③\n　↓
                  ・解説③・個別フィードバック・まとめ`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">こんな方におすすめ</StyledHeading>
                <TextCut cutPoint={240} size="Medium">
                  {`・難関企業への選考突破を目指す方\n・グループディスカッションで求められる本質的な力を知りたい方\n・本選考に向け、自分の改善ポイントを明確にしたい方`}
                </TextCut>
              </StyledEachItemWrapper>
              <StyledTableWrapper>
                <StyledHeading type="SubHero">開催概要</StyledHeading>
                <Table
                  items={[
                    {
                      name: "対象",
                      content: "2021年3月までに大学院・大学を卒業または卒業見込みの方",
                    },
                    {
                      name: "参加費",
                      content: "無料",
                    },
                    {
                      name: "参加特典",
                      content: "Infraのキャリアアドバイザー が本選考内定までサポート",
                    },
                    {
                      name: "持ち物",
                      content: "筆記用具・ノート",
                    },
                    {
                      name: "服装",
                      content: "自由。ラフな格好で構いません。",
                    },
                    {
                      name: "抽選・先着",
                      content: "お申し込み多数の場合は抽選とさせていただきます。",
                    },
                  ]}
                />
              </StyledTableWrapper>
              <StyledEachItemWrapper>
                <StyledHeading type="SubHero">開催場所</StyledHeading>
                <StyledPlace> 弊社代官山オフィス</StyledPlace>
                <StyledAddress>東京都渋谷区猿楽町30-8ツインビル代官山B棟303</StyledAddress>
              </StyledEachItemWrapper>
            </div>
          </Container>
        </StyledContainerWrapper>
        <Breadcrumb crumbs={crumbs} />
        <ActionWrapper className="gtm_seminar-apply">
          <CtaLink
            size="Medium"
            href={`https://docs.google.com/forms/d/1t66nJ7qGDR09w5iTEDRPaS9eZrmHbd7j1_G7CKU9GL0/edit`}
            target="_blank"
            disabled
          >
            募集終了
          </CtaLink>
        </ActionWrapper>
        <Footer />
      </>
    )
  }
}

const StyledContainerWrapper = styled.div`
  ${IsPC(css`
    padding: 48px 0;
  `)}
  ${IsMobile(css`
    padding: 24px 0 32px;
  `)}
`
const StyledEachItemWrapper = styled.div`
  margin-bottom: ${SpacingSize["2XL"]}px;
  &:last-child {
    margin-bottom: 0;
  }
`
const StyledHeading = styled(Typography)`
  margin-bottom: ${SpacingSize.XS}px;
  color: ${Color.Primary};
`
const StyledTableWrapper = styled.div`
  margin: 16px 0 32px;
`
const StyledPlace = styled.div`
  margin-bottom: ${SpacingSize["3XS"]}px;
  font-size: ${TextSize.M}px;
  font-weight: bold;
  line-height: ${LineHeight.M}%;
`
const StyledAddress = styled.div`
  line-height: ${LineHeight.M}%;
  color: ${Color.Gray};
  font-size: ${TextSize.S}px;
`
const StyledSchduleCardWrapper = styled.div`
  margin-top: ${SpacingSize["2XL"]}px;
  margin-bottom: ${SpacingSize["XL"]}px;
`
const ActionWrapper = styled.div`
  text-align: center;
  width: 100%;
  max-width: 480px;
  position: fixed;
  bottom: 16px;
  z-index: ${Z.Child};
  ${IsPC(css`
    left: 50%;
    margin-left: -240px;
  `)}
  ${IsMobile(css`
    padding: 0 16px;
    max-width: none;
    left: 0;
    margin-left: 0;
  `)}
`
